var Sliders = (function($) {
  let swiper = null;

  function initPartnersSlider() {
    const el = document.querySelector(".partners-slider");
    if (!el) return;
    if (swiper) return;

    swiper = new Swiper(el, {
      loop: true,
      speed: 700,

      autoplay: {
        delay: 1700,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },

      slidesPerView: 1,
      spaceBetween: 16,

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    });
  }

  function initArticleGallerySlider() {
    const el = document.querySelector(".post-gallery-slider");
    if (!el) return;
    if (swiper) return;

    swiper = new Swiper(el, {
      loop: true,
      speed: 700,

      // 👉 autoplay elegante
      //   autoplay: {
      //     delay: 1700,
      //     disableOnInteraction: false,
      //     pauseOnMouseEnter: true
      //   },

      // 👉 responsive
      slidesPerView: 1,
      spaceBetween: 16,

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    });
  }

  function init() {
    if (!$(".swiper").length) return;
    initPartnersSlider();
    initArticleGallerySlider();
  }

  return { init };
})(jQuery);

jQuery(document).ready(Sliders.init);
